import { render, staticRenderFns } from "./BlockDropZone.vue?vue&type=template&id=59660fad&scoped=true&"
import script from "./BlockDropZone.vue?vue&type=script&lang=js&"
export * from "./BlockDropZone.vue?vue&type=script&lang=js&"
import style0 from "./BlockDropZone.vue?vue&type=style&index=0&id=59660fad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59660fad",
  null
  
)

export default component.exports